import React, { ReactElement, useRef } from "react";
import { useWizard } from "react-use-wizard";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

interface StepTransitionProps {
  children: ReactElement;
  contentClassName?: string;
}

const StepTransition: React.FC<StepTransitionProps> = ({
  children,
  contentClassName,
}) => {
  const { activeStep } = useWizard();
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <div
      className={`${s.transitionContainer}${
        contentClassName ? ` ${contentClassName}` : ""
      }`}
    >
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={activeStep}
          nodeRef={nodeRef}
          timeout={200}
          classNames={{
            enter: s.stepEnter,
            enterActive: s.stepEnterActive,
            exit: s.stepExit,
            exitActive: s.stepExitActive,
          }}
        >
          <div ref={nodeRef} className={s.stepWrapper}>
            {children}
          </div>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};

export default withStyles(s)(StepTransition);